import { Dayjs } from "dayjs"
import { IWarrantsCommunicationGroup } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsCommunicationGroup implements IWarrantsCommunicationGroup {
  constructor(
    public id: number,
    public accountNumber: string,
    public status: string,
    public parentStatus: string,
    public currentPriorityLevel: number,
    public errorDescription: string | null,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }

  get parentStatusDisplay(): string {
    return sentenceCase(this.parentStatus)
  }
}
